// extracted by mini-css-extract-plugin
module.exports = {"boton":"MovimientosPatioPage_boton__S1Bnn"};